import { ApprovalMethodDateModel } from "./ApprovalMethodDateModel";
export let PendingAmendmentType = /*#__PURE__*/function (PendingAmendmentType) {
  PendingAmendmentType["NetTerms"] = "netTermsChange";
  PendingAmendmentType["AmendmentsApprovalMethod"] = "approvalMethod";
  PendingAmendmentType["InvoicesApprovalMethod"] = "invoicesApprovalMethod";
  PendingAmendmentType["AllowManualPayments"] = "manualPaymentsChange";
  PendingAmendmentType["CoverCreditCardFees"] = "coverCreditCardFees";
  return PendingAmendmentType;
}({});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export class PendingAmendmentModel {
  static fromDTO(dto) {
    switch (dto.type) {
      case PendingAmendmentType.NetTerms:
        return new PendingAmendmentNetTermsModel(dto);
      case PendingAmendmentType.AmendmentsApprovalMethod:
        return new PendingAmendmentAmendmentsApprovalMethodModel(dto);
      case PendingAmendmentType.InvoicesApprovalMethod:
        return new PendingAmendmentInvoicesApprovalMethodModel(dto);
      case PendingAmendmentType.AllowManualPayments:
        return new PendingAmendmentAllowManualPaymentsModel(dto);
      case PendingAmendmentType.CoverCreditCardFees:
        return new PendingAmendmentCoverCreditCardFeesModel(dto);
    }
  }
  constructor(data) {
    this.data = data;
    this.approvalMethodDateModel = ApprovalMethodDateModel.fromDTO(data.value.approvalMethod);
  }
  toDTO() {
    return this.data;
  }
  isCoverCreditCardFees() {
    return this.data.type === PendingAmendmentType.CoverCreditCardFees;
  }
  isNetTerms() {
    return this.data.type === PendingAmendmentType.NetTerms;
  }
  isAmendmentsApprovalMethod() {
    return this.data.type === PendingAmendmentType.AmendmentsApprovalMethod;
  }
  isInvoicesApprovalMethod() {
    return this.data.type === PendingAmendmentType.InvoicesApprovalMethod;
  }
  isAllowManualPayments() {
    return this.data.type === PendingAmendmentType.AllowManualPayments;
  }
  approvalMethod() {
    return this.approvalMethodDateModel;
  }
  changedOn() {
    return this.data.value.changedOn;
  }
}
export class PendingAmendmentNetTermsModel extends PendingAmendmentModel {
  constructor(data) {
    super(data);
    this.netTermsDTO = data;
  }
  value() {
    return this.netTermsDTO.value.value;
  }
}
export class PendingAmendmentAmendmentsApprovalMethodModel extends PendingAmendmentModel {
  constructor(data) {
    super(data);
    this.amendmentsApprovalMethodDTO = data;
  }
  value() {
    return this.amendmentsApprovalMethodDTO.value.value;
  }
}
export class PendingAmendmentInvoicesApprovalMethodModel extends PendingAmendmentModel {
  constructor(data) {
    super(data);
    this.invoicesApprovalMethodDTO = data;
  }
  value() {
    return this.invoicesApprovalMethodDTO.value.value;
  }
}
export class PendingAmendmentAllowManualPaymentsModel extends PendingAmendmentModel {
  constructor(data) {
    super(data);
    this.allowManualPaymentsDTO = data;
  }
  value() {
    return this.allowManualPaymentsDTO.value.value;
  }
}
export class PendingAmendmentCoverCreditCardFeesModel extends PendingAmendmentModel {
  constructor(data) {
    super(data);
    this.coverCCFeesDTO = data;
  }
  value() {
    return this.coverCCFeesDTO.value.value;
  }
}